<template>
  <div class="pos-relative o-hidden" style="min-height:100vh">
    <!-- Шейдер — фон всего блока входа (как на wanda.exchange) -->
    <Shader
      class="pos-absolute pos-t-0 pos-l-0 w-100 h-100 z-index-0"
      :theme="ds.theme.mode"
      shader="
        precision mediump float;
        uniform vec2 iResolution;
        uniform float iTime;
        uniform float iTheme;

        void main() {
          float mr = min(iResolution.x, iResolution.y);
          vec2 uv = (gl_FragCoord.xy * 2.0 - iResolution.xy) / mr;

          uv.x = -uv.x;

          float d = -iTime * 0.5;
          float a = 0.0;
          for (float i = 0.0; i < 8.0; ++i) {
            a += cos(i - d - a * uv.x);
            d += sin(uv.y * i + a);
          }
          d += iTime * 0.5;
          vec3 col = vec3(cos(uv * vec2(d, a)) * 0.6 + 0.4, cos(a + d) * 0.5 + 0.5);
          col = cos(col * cos(vec3(d, a, 2.5)) * 0.5 + 0.5);

          float intensity = (col.r + col.g + col.b) / 3.0;

          vec3 c1;
          vec3 c2;

          if (iTheme > 0.5) {
            c1 = vec3(0.275, 0.498, 0.929);
            c2 = vec3(1.0, 1.0, 1.0);
          } else {
            c1 = vec3(0.200, 0.200, 0.200);
            c2 = vec3(0.075, 0.075, 0.075);
          }

          col = mix(c1, c2, intensity);

          gl_FragColor = vec4(col, 1.0);
        }
      "
    />

    <!-- Контент поверх шейдера: карточка формы по центру экрана. -->
    <div class="pos-relative z-index-2 d-flex flex-center pd-medium" style="min-height:100vh">
      <router-view v-slot="{ Component, route }">
        <div class="w-100 w-max-30r bg-white radius-big pd-big mobile:pd-medium">
          <transition name="scaleIn" mode="out-in">
            <component
              ref="page"
              :key="route.path"
              :localPosition="localPosition"
              :is="Component"
            />
          </transition>
        </div>
      </router-view>

      <!-- Слайдер закомментирован — с ним много возни, вернёмся позже.
      <section
        class="desktop-only o-hidden radius-big h-100 t-white"
        style="background:rgba(0,0,0,0.35)"
      >
        <SliderFeatures/>
      </section>
      -->
    </div>
  </div>
</template>

<script setup>
import SliderFeatures from '@martyrs/src/modules/auth/views/components/sections/SliderFeatures.vue'
import Shader from '@martyrs/src/design-system/components/Shader/Shader.vue'
import { ds } from '@martyrs/src/design-system/index.js'

import { useRoute } from 'vue-router'

const route = useRoute()
</script>
